import lrQuery2 from './_src/lrQuery2.vue'

lrQuery2.install = function(Vue) {
  Vue.component(lrQuery2.name, lrQuery2)
}

export default lrQuery2